/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} New_Project_Drop_Frame_LabelInputs */

const en_new_project_drop_frame_label = /** @type {(inputs: New_Project_Drop_Frame_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drop Frame`)
};

const fr_new_project_drop_frame_label = /** @type {(inputs: New_Project_Drop_Frame_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drop frame`)
};

const de_new_project_drop_frame_label = /** @type {(inputs: New_Project_Drop_Frame_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fallrahmen`)
};

const it_new_project_drop_frame_label = /** @type {(inputs: New_Project_Drop_Frame_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Telaio a goccia`)
};

const ru_new_project_drop_frame_label = /** @type {(inputs: New_Project_Drop_Frame_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Опускающаяся рамка`)
};

const es_new_project_drop_frame_label = /** @type {(inputs: New_Project_Drop_Frame_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marco de caída`)
};

const zh_cn2_new_project_drop_frame_label = /** @type {(inputs: New_Project_Drop_Frame_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`掉帧`)
};

const ja_new_project_drop_frame_label = /** @type {(inputs: New_Project_Drop_Frame_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ドロップフレーム`)
};

const hi_new_project_drop_frame_label = /** @type {(inputs: New_Project_Drop_Frame_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ड्रॉप फ्रेम`)
};

const pt_pt2_new_project_drop_frame_label = /** @type {(inputs: New_Project_Drop_Frame_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quadro de queda`)
};

/**
* | output |
* | --- |
* | "Drop Frame" |
*
* @param {New_Project_Drop_Frame_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const new_project_drop_frame_label = /** @type {((inputs?: New_Project_Drop_Frame_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<New_Project_Drop_Frame_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_new_project_drop_frame_label(inputs)
	if (locale === "de") return de_new_project_drop_frame_label(inputs)
	if (locale === "it") return it_new_project_drop_frame_label(inputs)
	if (locale === "ru") return ru_new_project_drop_frame_label(inputs)
	if (locale === "es") return es_new_project_drop_frame_label(inputs)
	if (locale === "zh-CN") return zh_cn2_new_project_drop_frame_label(inputs)
	if (locale === "ja") return ja_new_project_drop_frame_label(inputs)
	if (locale === "hi") return hi_new_project_drop_frame_label(inputs)
	if (locale === "pt-PT") return pt_pt2_new_project_drop_frame_label(inputs)
	return en_new_project_drop_frame_label(inputs)
});